document
  .querySelector("product-recommendations")
  .addEventListener("loaded", () => {
    new Glide(".products-list-box-slider", {
      type: "slider",
      rewind: false,
      perView: 4,
      bound: true,
      swipeThreshold: false,
      dragThreshold: false,
      breakpoints: {
        950: {
          perView: 2,
          swipeThreshold: 80,
          dragThreshold: 120,
        },
        // 600: {
        //   perView: 1,
        //   swipeThreshold: 80,
        //   dragThreshold: 120,
        // },
      },
    }).mount()
  })
